import React from "react";
import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";

import { info } from "./Data";
import ReactLogo from "../assets/img/React.png";
import Next from "../assets/img/Next.png";
import Nest from "../assets/img/Nest.png";
import Node from "../assets/img/Node.png";
import Express from "../assets/img/expressjs.png";
import Mongo from "../assets/img/Mongo.png";
import Postgre from "../assets/img/Postgre.webp";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  return (
    <section className="skill">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn px-2">
              <h2>Skills</h2>
              <p className="px-3 px-sm-5 mb-5">{info.skillIntro}</p>

              <div className="row">
                {info.skills.map((section, index) => (
                  <div className="col-6 col-md-3" key={index}>
                    <h3>{section.title}</h3>
                    <p className="mb-4">
                      {section.skills.map((skill, skillIndex) => (
                        <React.Fragment key={skillIndex}>
                          {skill}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                ))}
              </div>

              <Carousel
                responsive={responsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={1200}
                arrows={false}
                className="owl-carousel owl-theme skill-slider mt-5"
              >
                <div className="item">
                  <a
                    href="https://legacy.reactjs.org/docs/getting-started.html"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={ReactLogo} alt="" />
                  </a>
                </div>

                <div className="item">
                  <a
                    href="https://nextjs.org/docs"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={Next} alt="" />
                  </a>
                </div>

                <div className="item">
                  <a
                    href="https://docs.nestjs.com/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      src={Nest}
                      style={{ transform: "scale(2)", paddingTop: "20px" }}
                      alt=""
                    />
                  </a>
                </div>

                <div className="item">
                  <a
                    href="https://nodejs.org/en/docs"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      src={Node}
                      style={{ transform: "scale(1.4)", paddingTop: "26px" }}
                      alt=""
                    />
                  </a>
                </div>

                <div className="item">
                  <a
                    href="https://expressjs.com/en/starter/installing.html"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      src={Express}
                      style={{ transform: "scale(1.8)", paddingTop: "12px" }}
                      alt=""
                    />
                  </a>
                </div>

                <div className="item">
                  <a
                    href="https://www.mongodb.com/docs/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      src={Mongo}
                      style={{ transform: "scale(1.1)" }}
                      alt=""
                    />
                  </a>
                </div>

                <div className="item">
                  <a
                    href="https://www.postgresql.org/docs/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      src={Postgre}
                      style={{ transform: "scale(1.3)" }}
                      alt=""
                    />
                  </a>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
